/**
 * Series registry (#539). Add a series by creating a file in this folder and
 * listing it here. `parts` holds blog post ids in reading order; posts are
 * looked up from the blog data, never copied, so the hub cannot drift.
 *
 * Keep this module free of `@/` imports and JSX: scripts/lib/series.js loads it
 * under plain Node for the sitemap, llms.txt and prerender manifest.
 */
import sharedTenantContentBoundary from './shared-tenant-content-boundary.js';
import copilotAgentGovernance from './copilot-agent-governance.js';
import copilotReadinessSharepoint from './copilot-readiness-sharepoint.js';
import copilotWaves from './copilot-waves.js';
import cyberActionMonth2026 from './cyber-action-month-2026.js';
import microsoft365Local from './microsoft-365-local.js';

export const allSeries = [
  sharedTenantContentBoundary,
  copilotAgentGovernance,
  copilotReadinessSharepoint,
  copilotWaves,
  cyberActionMonth2026,
  microsoft365Local,
];

export const getSeriesBySlug = (slug) => allSeries.find((s) => s.slug === slug);

export const getSeriesForPostId = (postId) =>
  allSeries.find((s) => s.parts.some((p) => p.id === Number(postId)));

export const getPartNumber = (series, postId) =>
  series.parts.findIndex((p) => p.id === Number(postId)) + 1;

export default allSeries;
